import gql from "graphql-tag";

const EVENTS_QUERY = gql`
query Events($chapterId: String!){
    events(chapterId: $chapterId){
        Active
        Cancelled
        ChapterId
        ChapterName
        EventLookupId
        EventStartDate
        EventStartTime
        EventEndDate
        EventEndTime
        EventName
        EventCategory
        CancelledDate
        CancelledComment
    }
}`

export default EVENTS_QUERY;